import React from "react";
import eventosData from "../assets/eventos.json";

function EventosPage() {
  return (
    <div>
      <section className="content-section">
        <h1>Eventos</h1>
        <p>Descubre nuestras noches temáticas y eventos especiales:</p>
        <ul
          style={{
            textAlign: "left",
            margin: "20px auto",
            maxWidth: "400px",
            lineHeight: "1.8",
          }}
        >
          {eventosData.eventos.map((evento, index) => (
            <li key={index}>
              <strong>{evento.nombre}</strong> - {evento.descripcion}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default EventosPage;
